import { createContext } from "react";
const UserContext = createContext({
  basePath: "",
  isAmazonPrime: false,
  isDesktop: false,
  authorizedMobileNumber: "",
  isNewCar: false,
  isFlutterInAppWebViewReady: false,
  abVersions: {
    freshCarQuote: 0,
    newCarPrequote: 0
  },
  product: "",
  isBike: false,
  isGpay: false,
  showChatbot: false,
  canRenderHelp: false
});

export default UserContext;
